<div class="header-container">
  <div class="logo-container" *ngIf="routerUrl == 'portal' && isProfileCompleted">
    <a href="#" class="sidebar-toggle" matRipple [matRippleUnbounded]="true" [matRippleCentered]="true"
      (click)="toggleSidebar()">
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a>
    <img class="logo-icon on-web-logo"
      [src]="currentTheme == 'material-light' ? 'assets/img/logo-stf-full-01.png'  : 'assets/img/logo-icon-dark.png' "
      alt="Logo">
    <img class="logo-icon-mobile on-mobile-logo"
      [src]="currentTheme == 'material-light' ? 'assets/img/logo-stf-full-01.png'  : 'assets/img/logo-icon-2-dark.png' "
      alt="Logo">
    <!--  <a href="#" class="tipo-portal">{{title}}</a> -->
  </div>
  <div class="logo-container" *ngIf="routerUrl == 'public' || !isProfileCompleted">
    <img class="logo-icon-not-login on-web-logo" (click)="goTo('home')"
      [src]="currentTheme == 'material-light' ? 'assets/img/logo-stf-full-01.png'  : 'assets/img/logo-icon-dark.png' "
      alt="Logo">
    <img class="logo-icon-mobile-not-login on-mobile-logo" (click)="goTo('home')"
      [src]="currentTheme == 'material-light' ? 'assets/img/logo-stf-full-01.png'  : 'assets/img/logo-icon-2-dark.png' "
      alt="Logo">
  </div>
</div>

<div class="header-container">
  <nb-actions size="small" *ngIf="routerUrl == 'portal'" nbTooltipDisabled="true" matRipple [matRippleUnbounded]="true" matRippleRadius="20" style="cursor: pointer;">
    <nb-action class="control-item text-username show-all-info">
      <span style="font-size: 14px;">{{username}}</span> <br>
      <!-- <span style="font-size: 11px;">{{lastConnectionTitle}}: {{lastConnection | date:'dd/MM/yyyy hh:mm a'}}</span> <br> -->
      <div class="div-role-selection">
        <span style="text-transform: capitalize;">{{rolename.toLowerCase()}} </span>
      </div> 
      <ng-container *ngIf="isClubStaff && sportGroup">
        <br>
        <div class="div-role-selection">
          <span style="text-transform: capitalize;">{{sportGroup.name ? sportGroup.name.toLowerCase() : '' }} </span>
        </div>
      </ng-container>
    </nb-action>

    <!-- <nb-action *ngIf="currentTheme == 'material-dark'" class="control-item text-username on-web"
      style="cursor: pointer;" (click)="changeTheme('material-light')">
      <nb-icon class="change-theme" icon="sun-outline"></nb-icon>
    </nb-action>

    <nb-action *ngIf="currentTheme == 'material-light'" class="control-item text-username on-web "
      style="cursor: pointer;" (click)="changeTheme('material-dark')">
      <nb-icon class="change-theme" icon="sun"></nb-icon>
    </nb-action> -->

    <!--   <nb-action *ngIf="languageSelected == 'en-US'" class="control-item text-username" style="cursor: pointer;"
      (click)="selectLanguage('es-ES')">
      <span>ES</span>
    </nb-action>

    <nb-action *ngIf="languageSelected == 'es-ES'" class="control-item text-username" style="cursor: pointer;"
      (click)="selectLanguage('en-US')">
      <span>EN</span>
    </nb-action> -->


    <nb-action class="user-action" >
      <mat-progress-spinner *ngIf="isLoadingPicture || isLoadingLogout" color="accent" mode="indeterminate" diameter="25"
        style="margin: auto;">
      </mat-progress-spinner>
      <nb-user class="icon-aling-popOver" data-test-id="logged-in-user-icon" *ngIf="!isLoadingPicture && !isLoadingLogout" [onlyPicture]="userPictureOnly" [name]="usuario?.nombre" [picture]="picture" [nbPopover]="menuHeader">
      </nb-user>
    </nb-action>


  </nb-actions>

  <ng-template #menuHeader>
    <ngx-header-menu [user]="user" [picture]="picture" (onAction)="onMenuSelection($event)"></ngx-header-menu>
  </ng-template>

  <nb-actions size="small" *ngIf="routerUrl == 'public'">
    <!--
    <nb-action class="no-control-item text-username button-item on-web">
      <span style="font-size: 1rem;">
        Welcome To STF
      </span>
    </nb-action>
     <nb-action class="no-control-item text-username button-item on-web" style="cursor: pointer;" (click)="goTo('club')">
      <button nbButton matRipple status="primary">
        {{signupTitle}}
      </button>
    </nb-action>

      <nb-action class="no-control-item text-username button-item on-web" style="cursor: pointer;"
      (click)="goTo('talentFinder')">
      <button nbButton matRipple status="warning">
        {{joinTalentFinderTitle}}
      </button>
    </nb-action>

    <nb-action class="no-control-item text-username button-item on-web" style="cursor: pointer;" (click)="goTo('stf')">
      <button nbButton matRipple status="info">
        {{ joinSTFStaffTitle }}
      </button>
    </nb-action>

    <nb-action class="no-control-item text-username button-item on-web" style="cursor: pointer;"
      (click)="goTo('athlete')">
      <button nbButton matRipple>
        {{ signupTitle }}
      </button>
    </nb-action> -->

    <!--  <nb-action class="user-action on-web" style="cursor: pointer;" (click)="goTo('login')">
      <button nbButton size="large">
        <nb-icon icon="user" pack="fa" style="font-size: 1.6rem;"></nb-icon>
      </button>
    </nb-action>
 -->
  <!--   <nb-action class="no-control-item  on-mobile home-side-toggle" style="cursor: pointer;">
      <nb-icon [nbContextMenu]="homeMenu" nbContextMenuTag="home-menu-context"
        [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </nb-action> -->
  </nb-actions>



</div>